import { render, staticRenderFns } from "./Household.vue?vue&type=template&id=1ef19b32&"
import script from "./Household.vue?vue&type=script&lang=js&"
export * from "./Household.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports